var fn = function( obj ){
var __t,__p='';
__p+='varying vec2 vTexCoord;\n\nuniform sampler2D tTex;\nuniform vec4 uScaleMode;\nuniform float uProcessMode;\n\nvoid main(void){\n\n  vec3 c = texture2D(tTex, vTexCoord).rgb;\n  vec3 frame = c * uScaleMode.rgb;\n  frame = vec3(1.0) * clamp(frame.r + frame.g + frame.b, 0.0, 1.0);\n\n  c *= (1.0 - uProcessMode);\n  \n  gl_FragColor = vec4(mix(c, frame, uScaleMode.w), 1.0);\n}';
return __p;
};
fn.toString=fn;
module.exports = fn;